<div class="footer">
  <div class="container">
    <div class="row">
      <div class="col-sm-6 col-md-3 text-center-md-max">
        <div class="footer-logo"></div>

        <div class="social-links font-2xl mt-2">
          <a [href]="urls.instagram" target="_blank" rel="noopener" aria-label="Cake it easy instagram link"><i
            class="icon-instagram"></i></a>
          <a [href]="urls.facebook" target="_blank" rel="noopener" aria-label="Cake it easy Facebook link"><i
            class="icon-facebook"></i></a>
        </div>

        <div class="font-xs mt-4 available-in"
             [translate]="'footerLayout.availableIn.title'">Available in
        </div>

        <country-selector></country-selector>
      </div>

      <div class="col-sm-6 col-md-3 links-col"
           [class.links-col-first]="!i"
           *ngFor="let linksBlock of footerLinks; let i=index">

        <div class="fw-bold">{{linksBlock.title}}</div>

        <div class="font-md mt-md-min-3 mt-sm-max-2">
          <ng-container *ngIf="!i && giftCardsEnabled">
            <div class="footer-link">
              <a class="text-muted" href="#"
                 (click)="$event.preventDefault(); goToGiftCards();"
                 [translate]="'orderProcess.cakesOverview.header.giftCards'">Gift cards</a>
            </div>
          </ng-container>

          <ng-container *ngIf="!i">
            <div class="footer-link">
              <a class="text-muted" href="#"
                 (click)="$event.preventDefault(); showFAQ();"
                 [translate]="'footerLayout.faq'">FAQ</a>
            </div>
          </ng-container>

          <ng-container *ngIf="i === 1">
            <div class="footer-link">
              <a class="text-muted" href="#"
                 (click)="$event.preventDefault(); showHowItWorks();"
                 [translate]="'footerLayout.howItWorks'">How it works</a>
            </div>
          </ng-container>

          <div class="footer-link"
               *ngFor="let link of linksBlock.links">
            <a class="text-muted"
               [href]="link.href">{{link.title}}</a>
          </div>

          <ng-container *ngIf="!i">
            <div class="footer-link">
              <a class="text-muted"
                 href="#"
                 [translate]="'footerLayout.contactUs'"
                 (click)="$event.preventDefault(); showContactUs();">Contact us</a>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="language-copyright-and-logos">
      <div class="payment-logos">
        <img class="p-logo-item p-logo-vipps" *ngIf="isNOLocale"
             alt="payment vipps"
             src="/assets/img/payment-logo/vipps.svg">

        <img class="p-logo-item p-logo-swish" *ngIf="isSELocale"
             alt="payment swish"
             src="/assets/img/payment-logo/swish.svg">

        <img class="p-logo-item p-logo-visa"
             alt="payment visa"
             src="/assets/img/payment-logo/visa.svg">
        <img class="p-logo-item p-logo-mastercard"
             alt="payment mastercard"
             src="/assets/img/payment-logo/mastercard.svg">
        <img class="p-logo-item p-logo-klarna"
             alt="payment klarna"
             src="/assets/img/payment-logo/klarna.svg">
        <div class="p-logo-item p-logo-faktura"
             [innerHTML]="'orderProcess.payment.companyInvoiceOnEmailAndEHF' | translate"></div>
      </div>

      <div class="language-and-copyright">
        <language-selector-dropdown
        ></language-selector-dropdown>

        <div class="font-md copyright" *ngIf="isSELocale">
          © {{ currentYear }} Cake it easy AB
        </div>

        <div class="font-md copyright" *ngIf="!isSELocale">
          © {{ currentYear }} Cake it easy AS
        </div>
      </div>
    </div>

  </div>
</div>
